export const glossary = {
  acquired: "acquired",
  acquired_capitalize: "Acquired",
  new: "new",
  new_capitalize: "New",
  existing: "existing",
  existing_capitalize: "Existing"
};
